import {memo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {setActivePoiRoute} from "../../../maps/actions/set_poi_travel_directions";
import {LocationPoisSummary} from "../../../maps/components/LocationPoisSummary";
import {useTransportPoisStats} from "../../../maps/hooks/use_transport_pois";
import {hitGtmBusRouteClick} from "../../../maps/tracking/routes_gtm_events";
import {trackAmplitudePoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {IPublicTransportRoute} from "../../../maps/types/IPublicTransportRoute";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail | IPropertyDetailOffer;
    propertyId?: number;
    onTransportRoutesExpand?: () => void;
    routes?: {
        busRoutes: IPublicTransportRoute[] | null;
        railwayRoutes: IPublicTransportRoute[] | null;
        subwayRoutes: IPublicTransportRoute[] | null;
        tramRoutes: IPublicTransportRoute[] | null;
    };
}

export const OfferDetailLocationSummary = memo((props: IProps) => {
    const dispatch = useDispatch();

    const poisStats = useSelector((state: IRPStore) => state.offerDetail.poisStats);
    const activePoiRoute = useSelector((state: IRPStore) => state.maps.travelDirections.activePoiRoute);
    const {subwayPoi, railwayPoi, tramPoi, busPoi} = useTransportPoisStats();

    const onTransportRouteClick = (poiRoute: IPublicTransportRoute) => {
        trackAmplitudePoiClick({
            location: props.propertyId != null ? "property_page" : "investment_page",
            route: poiRoute,
            itemId: props.offer.id,
            propertyId: props.propertyId ?? null
        });
        dispatch(setActivePoiRoute(poiRoute.id === activePoiRoute?.id ? null : poiRoute));
        hitGtmBusRouteClick();
    };

    if (!getHasCountryPois(props.offer.region.country)) {
        return null;
    }

    return (
        <div data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_PUBLIC_TRANSPORT_SECTION}>
            <LocationPoisSummary
                offer={props.offer}
                country={props.offer.region.country}
                subwayPoi={subwayPoi}
                railwayPoi={railwayPoi}
                tramPoi={tramPoi}
                busPoi={busPoi}
                nearestPoisCount={poisStats?.poi?.nearest_pois_count}
                routes={props.routes ?? null}
                activePoiRoute={activePoiRoute}
                onTransportRouteClick={onTransportRouteClick}
                onTransportRoutesExpand={props.onTransportRoutesExpand}
                nearbySubject="inwestycji"
                className={poiWrapperStyle}
            />
        </div>
    );
});

const poiWrapperStyle = css({
    px: 1.5,
    pt: 2,
    md: {
        px: 3,
        pt: 3
    }
});
import {memo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {setActivePoiRoute} from "../../../maps/actions/set_poi_travel_directions";
import {LocationPoisSummary} from "../../../maps/components/LocationPoisSummary";
import {useTransportPoisStats} from "../../../maps/hooks/use_transport_pois";
import {hitGtmBusRouteClick} from "../../../maps/tracking/routes_gtm_events";
import {trackAmplitudePoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {IPublicTransportRoute} from "../../../maps/types/IPublicTransportRoute";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail | IPropertyDetailOffer;
    propertyId?: number;
    onTransportRoutesExpand?: () => void;
    routes?: {
        busRoutes: IPublicTransportRoute[] | null;
        railwayRoutes: IPublicTransportRoute[] | null;
        subwayRoutes: IPublicTransportRoute[] | null;
        tramRoutes: IPublicTransportRoute[] | null;
    };
}

export const OfferDetailLocationSummary = memo((props: IProps) => {
    const dispatch = useDispatch();

    const poisStats = useSelector((state: IRPStore) => state.offerDetail.poisStats);
    const activePoiRoute = useSelector((state: IRPStore) => state.maps.travelDirections.activePoiRoute);
    const {subwayPoi, railwayPoi, tramPoi, busPoi} = useTransportPoisStats();

    const onTransportRouteClick = (poiRoute: IPublicTransportRoute) => {
        trackAmplitudePoiClick({
            location: props.propertyId != null ? "property_page" : "investment_page",
            route: poiRoute,
            itemId: props.offer.id,
            propertyId: props.propertyId ?? null
        });
        dispatch(setActivePoiRoute(poiRoute.id === activePoiRoute?.id ? null : poiRoute));
        hitGtmBusRouteClick();
    };

    if (!getHasCountryPois(props.offer.region.country)) {
        return null;
    }

    return (
        <div data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_PUBLIC_TRANSPORT_SECTION}>
            <LocationPoisSummary
                offer={props.offer}
                country={props.offer.region.country}
                subwayPoi={subwayPoi}
                railwayPoi={railwayPoi}
                tramPoi={tramPoi}
                busPoi={busPoi}
                nearestPoisCount={poisStats?.poi?.nearest_pois_count}
                routes={props.routes ?? null}
                activePoiRoute={activePoiRoute}
                onTransportRouteClick={onTransportRouteClick}
                onTransportRoutesExpand={props.onTransportRoutesExpand}
                nearbySubject="inwestycji"
                className={poiWrapperStyle}
            />
        </div>
    );
});

const poiWrapperStyle = css({
    px: 1.5,
    pt: 2,
    md: {
        px: 3,
        pt: 3
    }
});
